"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImageElementFromUrl = void 0;
var getImageElementFromUrl = function (url) {
    return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () { return resolve(img); };
        img.onerror = reject;
        img.src = url;
    });
};
exports.getImageElementFromUrl = getImageElementFromUrl;
